export class MaintenanceModeConfigConstants {
    static FORM_HEADER = "System settings";
    static SECTION_AVAILABILITY_HEADING = "Availability";
    static MAINTENANCE_MODE_TEXT = "Maintenance mode";
    static MAINTENANCE_MODE_DESCRIPTION_TEXT = "When enabled, only administrators can access the system. All other users will see a maintenance notice.";
    static ENABLE_BUTTON_TEXT = "Enable";
    static DISABLE_BUTTON_TEXT = "Disable";
    static ENABLED_LABEL_TEXT = "Enabled";
    static DISABLED_LABEL_TEXT = "Disabled";
    static MAINTENANCE_MODE_ACTIVE_TEXT = "Maintenance mode active";
    static MAINTENANCE_MODE_DISABLED_TEXT = "Currently disabled — system is live";
    static MAINTENANCE_MODE_NOTICE_TEXT = "Changes to system settings apply immediately and affect all users. Only administrators can modify these settings.";
}
